import React from 'react';
import { Row, Col } from 'antd';

/**
 * Full-width page wrapper (replaces bare div roots).
 */
const PageShell = ({ children, className }) => (
  <Row className={className}>
    <Col span={24}>{children}</Col>
  </Row>
);

export default PageShell;
